var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDimensionBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9958 20.1595L13.6999 2.8847L49.5871 2.81475L53.5998 20.0687L32.1213 25.2738",
    fill: "#E9BB91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5975 18.9553L6.99341 19.0461L7.06217 54.3263L53.6662 54.2355L53.5975 18.9553Z",
    fill: "#CA936C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9634 18.9935L33.9825 28.7871L26.6466 28.8013L26.6275 19.0078L27.4491 7.68139L33.0977 7.67038L33.9634 18.9935Z",
    fill: "#764F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0126 44.4793L26.6768 44.4936L26.6958 54.2871L34.0317 54.2728L34.0126 44.4793Z",
    fill: "#764F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6278 19.0075L27.4492 7.68148L33.0982 7.67047L33.9637 18.9932",
    fill: "#8E6459"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2509 42.9171L12.4308 41.7325L12.4418 47.378C12.4425 47.772 12.7625 48.0907 13.1565 48.09C13.5506 48.0892 13.8693 47.7692 13.8685 47.3752L13.8575 41.7298L15.0419 42.9096C15.1815 43.0487 15.3642 43.1179 15.5468 43.1176C15.7293 43.1172 15.9117 43.0472 16.0508 42.9076C16.3289 42.6285 16.328 42.1768 16.0489 41.8989L13.6443 39.5036C13.5103 39.3701 13.3287 39.2952 13.1395 39.2956C12.9503 39.296 12.7691 39.3714 12.6354 39.5056L10.2402 41.9102C9.96209 42.1893 9.96298 42.641 10.2421 42.9189C10.5211 43.197 10.9728 43.1962 11.2509 42.9171Z",
    fill: "#764F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3837 42.9032L19.5635 41.7187L19.5745 47.3642C19.5753 47.7581 19.8952 48.0769 20.2892 48.0762C20.6833 48.0754 21.002 47.7554 21.0012 47.3614L20.9902 41.7159L22.1746 42.8958C22.3143 43.0348 22.4969 43.1041 22.6795 43.1038C22.862 43.1034 23.0445 43.0334 23.1835 42.8938C23.4616 42.6147 23.4607 42.163 23.1816 41.8851L20.7771 39.4898C20.643 39.3563 20.4614 39.2814 20.2722 39.2818C20.083 39.2822 19.9018 39.3576 19.7682 39.4918L17.373 41.8964C17.0949 42.1755 17.0958 42.6272 17.375 42.9051C17.654 43.1831 18.1056 43.1822 18.3837 42.9032Z",
    fill: "#764F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6453 49.1176L10.8047 49.1407C10.4106 49.1415 10.0919 49.4615 10.0927 49.8554C10.0935 50.2494 10.4134 50.5682 10.8074 50.5674L22.648 50.5443C23.042 50.5436 23.3607 50.2235 23.3599 49.8296C23.3592 49.4356 23.0393 49.1168 22.6453 49.1176Z",
    fill: "#764F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0451 23.8119L37.3489 23.8366L37.3681 33.6805L50.0643 33.6558L50.0451 23.8119Z",
    fill: "#F5FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3903 27.7434L40.1148 27.7575C39.7208 27.7583 39.4008 27.4395 39.4001 27.0456C39.3993 26.6516 39.718 26.3316 40.112 26.3308L47.3876 26.3167C47.7816 26.3159 48.1015 26.6347 48.1023 27.0286C48.1031 27.4226 47.7844 27.7426 47.3903 27.7434Z",
    fill: "#764F43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3972 31.1616L40.1217 31.1757C39.7276 31.1765 39.4077 30.8577 39.4069 30.4638C39.4061 30.0698 39.7248 29.7498 40.1189 29.749L47.3944 29.7349C47.7884 29.7341 48.1084 30.0529 48.1091 30.4468C48.1099 30.8408 47.7912 31.1608 47.3972 31.1616Z",
    fill: "#764F43"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.7467 60.1753C52.8436 60.0785 52.8436 59.9215 52.7467 59.8247L51.1691 58.2471C51.0723 58.1503 50.9154 58.1503 50.8185 58.2471C50.7217 58.3439 50.7217 58.5009 50.8185 58.5977L52.2209 60L50.8185 61.4023C50.7217 61.4991 50.7217 61.6561 50.8185 61.7529C50.9154 61.8497 51.0723 61.8497 51.1691 61.7529L52.7467 60.1753ZM6.95801 60.2479H52.5715V59.7521H6.95801V60.2479Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.17498 18.6731C2.07798 18.5765 1.92102 18.5768 1.8244 18.6738L0.249852 20.2545C0.153231 20.3515 0.153536 20.5085 0.250536 20.6051C0.347535 20.7017 0.504495 20.7014 0.601117 20.6044L2.00071 19.1993L3.40577 20.5989C3.50277 20.6956 3.65973 20.6952 3.75635 20.5982C3.85297 20.5012 3.85267 20.3443 3.75567 20.2477L2.17498 18.6731ZM2.31943 55.5373L2.24793 18.8483L1.75213 18.8492L1.82363 55.5382L2.31943 55.5373Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.64046 0.89551C9.58274 0.771364 9.4353 0.717515 9.31115 0.775236L7.28804 1.71588C7.1639 1.7736 7.11005 1.92103 7.16777 2.04518C7.22549 2.16933 7.37293 2.22318 7.49708 2.16546L9.2954 1.32933L10.1315 3.12765C10.1892 3.2518 10.3367 3.30565 10.4608 3.24793C10.585 3.1902 10.6388 3.04277 10.5811 2.91862L9.64046 0.89551ZM4.21601 15.959L9.64852 1.08507L9.18282 0.91498L3.7503 15.7889L4.21601 15.959Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.605,
    height: 53.2355,
    fill: "white",
    transform: "translate(6.95801 1.09083) rotate(-0.111665)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimensionBox);
export default __webpack_public_path__ + "static/media/dimension-box.c329c84be555a75630f663da60bec3fc.svg";
export { ForwardRef as ReactComponent };